import Box from 'carbon-react/esm/components/box';
import DateRangeComponent from '../../../components/DateRange';
import FilterPopover from '../component/FilterPopover';
import ModesButtonBar from '../component/FilterMode';
import FilterStatusButtonBar from '../component/FilterStatus';
import SearchDeclarations from '../component/FilterSearch';
import DownloadButton from '../component/DownloadButton';
import FilterLayoutProps from '../types/filterlayout.types';
import {
  DateRangePreset,
  DateRangePresetCustom,
  DateRangePresetDays30,
} from '../../../utils/dateHelpers';
import FilterDateRangePresets from '../component/FilterDateRangePresets';

const FilterLayout = ({
  selectedUserIdState,
  startDate,
  endDate,
  selectedNatures,
  onFilterChange,
  onSelectChange,
  onDateRangeChange,
  onNatureChange,
  onSubmitFilters,
  selectedStatus,
  isTest,
  onSearch,
  searchValue,
  onStatusChange,
  onModeChange,
  selectedDatePreset,
  onDatePresetChange,
  selectedRows,
  data,
}: FilterLayoutProps) => {
  const handleModeChangeAndSubmit = (mode: boolean) => {
    onModeChange(mode);
  };

  const handleStatusChangeAndSubmit = (status: string) => {
    onStatusChange(status);
  };

  const handleSearch = (value: string) => {
    onSearch(value);
  };

  const handleDatePresetChange = (preset: DateRangePreset) => {
    if (onDatePresetChange) {
      onDatePresetChange(preset);
    }
  };

  const dateRangePreset = selectedDatePreset || DateRangePresetDays30;

  return (
    <>
      <Box display="flex" flexDirection="column" maxWidth="auto">
        <Box display="flex" flexDirection="row" alignItems="flex-end">
          <Box ml={16} minWidth={190}>
            <FilterDateRangePresets
              onPresetChange={handleDatePresetChange}
              selectedPreset={dateRangePreset}
            />
          </Box>
          {dateRangePreset === DateRangePresetCustom && (
            <Box ml={16}>
              <DateRangeComponent
                value={[
                  startDate ? startDate.toISOString() : '',
                  endDate ? endDate.toISOString() : '',
                ]}
                onChange={onDateRangeChange}
                // onValidationChange={isValid => {
                // }}
              />
            </Box>
          )}
          <Box ml={16} pr={16} minWidth={420}>
            <SearchDeclarations onSearch={handleSearch} value={searchValue} />
          </Box>
          <Box ml={16}>
            <FilterPopover
              selectedUserIdState={selectedUserIdState}
              selectedNatures={selectedNatures}
              onFilterChange={onFilterChange}
              onSelectChange={onSelectChange}
              onNatureChange={onNatureChange}
              onSubmitFilters={onSubmitFilters}
            />
          </Box>
        </Box>
      </Box>
      <Box
        display="flex"
        flexDirection="row"
        alignItems={'center'}
        justifyContent="space-between"
        maxWidth="100%"
      >
        <Box display="flex" flexDirection="row" alignItems="flex-end">
          <Box ml={16} minWidth={190}>
            <ModesButtonBar isTest={isTest} onModeChange={handleModeChangeAndSubmit} />
          </Box>
          <Box ml={16}>
            <FilterStatusButtonBar
              onStatusChange={handleStatusChangeAndSubmit}
              selectedStatus={selectedStatus}
            />
          </Box>
        </Box>
        <Box display="flex" alignItems="flex-end" pt={2} pr={16}>
          {selectedRows && data && <DownloadButton selectedRows={selectedRows} data={data} />}
        </Box>
      </Box>
    </>
  );
};

export default FilterLayout;
